export const COLORS = {
  white: '#fff',
  grey70: '#515151',
  orange80: '#CF6D16',
  purple: '#AB22FF',
  grey20: '#D2D2D2',
  yellow80: '#F5AF00',
  green60: '#4CAF50',
  blue60: '#2196F3',
};
